export default __webpack_public_path__ + "static/media/05.d646a7cb.webp";